module.exports = __webpack_public_path__ + "img/android-qrcode.1f309430.png";